<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12">
          <button type="button" (click)="show()" id="btn_AddNew" style="display:none">Add</button>
          <div class="col-sm-12" style="top:-10px;">
            <input #fileInput type="file" (change)="onuploadSelected($event)" id="doc_Importfile" style="display:none" />
            <button type="button" id="fileupload" (click)="fileupload()" style="display:none">Get</button>
            <div class="row">
              <div class="col-sm-3">
                <label>Journal</label>
                <select id="ddlJournalList" class="form-control select2">
                  <option [value]="0" selected="selected">Select</option>
                  <option *ngFor="let item of JournalList" value={{item.ID}}>
                    {{item.Acronym}}
                  </option>
                </select>
              </div>
              <div class="col-sm-3">
                <br>
                <button type="button" class="btn btn-outline-info waves-effect waves-light" id="btnLoadList" (click)="GetIssueConfigList()">Search</button>
              </div>
              <div class="col-sm-6 text-right">
                <br>
                <button type="button" class="btn btn-outline-primary waves-effect waves-light" id="btndownload" (click)="downloadFile()"><i class="fa fa-download"></i> Download Sample File</button>&nbsp;
                <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnUpload" (click)="fileInput.click()"><i class="fa fa-upload"></i> Import Excel</button>
              </div>
            </div>
          </div>
          <br>
          <table #dataTable class="display" style="width:100%"></table>

          <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ title }}</h4>
                  <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
                </div>
                <div class="modal-body" id="popupbody">
                  <form #form="ngForm">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Journal</label>
                          <select id="ddlJournalListPop" class="form-control select2">
                            <option [value]="0" selected="selected">Select</option>
                            <option *ngFor="let item of JournalList" value={{item.ID}}>
                              {{item.Acronym}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Year</label>
                          <select id="ddlYearListPop" class="form-control select2">
                            <option [value]="0" selected="selected">Select</option>
                            <option *ngFor="let item of YearList" value={{item.Year}}>
                              {{item.Year}}
                            </option>
                          </select>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Volume/Year</label>
                          <input type="text" id="Txt_Volume" [(ngModel)]="Txt_Volume" name="Txt_Volume" class="form-control" autocomplete="off" maxlength="{{modelItem.VolumeMaxChar}}" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Issue/Year</label>
                          <input type="text" id="Txt_Issue" [(ngModel)]="Txt_Issue" name="Txt_Issue" class="form-control" autocomplete="off" maxlength="{{modelItem.IssueMaxChar}}" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Pages/Issue</label>
                          <input type="text" id="Txt_Pages" [(ngModel)]="Txt_Pages" name="Txt_Pages" class="form-control" autocomplete="off" maxlength="{{modelItem.PagesMaxChar}}" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>AnnualBudget</label>
                          <input type="text" id="Txt_AnnualBudget" [(ngModel)]="Txt_AnnualBudget" name="Txt_AnnualBudget" class="form-control" autocomplete="off" maxlength="{{modelItem.AnnualBudget}}" />
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Signature Count/Divisibility</label>
                          <select id="ddlSignatureCount" class="form-control select2">
                            <option value="0" selected="selected">Select</option>
                            <option value="4">4</option>
                            <option value="8">8</option>
                            <option value="12">12</option>
                            <option value="16">16</option>
                            <option value="24">24</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Issue to Print</label>
                          <select id="ddlIssuetoPrint" class="form-control select2">
                            <option value="Select" selected="selected">Select</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Issue Online</label>
                          <select id="ddlIssueOnline" class="form-control select2">
                            <option value="Select" selected="selected">Select</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>TOC on cover</label>
                          <select id="ddlTOConCover" class="form-control select2">
                            <option value="Select" selected="selected">Select</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Index</label>
                          <select id="ddlIndex" class="form-control select2">
                            <option value="Select" selected="selected">Select</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Spine Width (inches)</label>
                          <input type="text" id="Txt_SpineWidth" class="form-control" autocomplete="off" OnlyNumber  />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Volume Start Folio</label>
                          <input type="text" id="Txt_VolumeStartFolio" class="form-control" autocomplete="off" OnlyNumber  />
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Article Start</label>
                          <select id="ddlArticleStart" class="form-control select2">
                            <option value="0" selected="selected">Select</option>
                            <option value="Continious">Continious</option>
                            <option value="New Pages">New Pages</option>
                            <option value="Odd Number">Odd Number</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Issue Workflow</label><br />
                          <input type="checkbox" id="ChkPE" /> PE &nbsp;&nbsp;
                          <input type="checkbox" id="ChkEditor" /> Editor
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>BackLogIssue</label><br />
                          <input type="checkbox" id="Chk_BackLogIssue" />                        
                        </div>
                      </div>
                      <div class="col-md-3" style="display:none">
                        <div class="form-group">
                          <label>IOG NT</label>
                          <select id="ddlIOGNT" class="form-control select2">
                            <option value="Select" selected="selected">Select</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-12">                       
                          <label>Generic Instruction</label>
                          <textarea id="Txt_GenericInstruction"  class="form-control" autocomplete="off" rows="5"></textarea>                      
                      </div>
                    </div>
                  </form>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                  <button type="button" class="btn btn-outline-success waves-effect waves-light" value="{{ popUpButtonText }}" (click)="UpdateData()"> {{ popUpButtonText }} </button>
                </div>

                <div id="LoadingImagePopup">
                  <img src="assets/Images/loader.gif" class="imgLoadimg" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
